import React from 'react';
import PropTypes from 'prop-types';
import './timeMainGoods.less';
// import store from '../../store';
import Swiper from '../../com/swiper-3.3.1.min';
import { observer } from 'mobx-react';

interface timeMainGoodsPropType {
    prefixCls?: string;
    goodsList?: any[];
    onAddShop?: (data) => void; // 加入购物车
    toAppDetail?: (data) => void; // 跳转至商品详情
    onSpecialClick?: (data) => void; // 跳转至专题
    type?: number;
}

@observer
class TimeMainGoods extends React.Component<timeMainGoodsPropType, any> {
    static defaultProps = {
        prefixCls: 'timeMainGoods',
    };

    static contextTypes = {
        router: PropTypes.object
    };

    constructor(props, context) {
        super(props, context);
    }

    swiper: any = [];
    goodsList: any;

    componentDidMount() {

    };

    componentWillReceiveProps(nextProps) {
        if (JSON.stringify(nextProps.goodsList) != JSON.stringify(this.goodsList)) {
            this.goodsList = nextProps.goodsList;
            nextProps.goodsList && nextProps.goodsList.map((data: any) => {
                data.timerShaftModules && data.timerShaftModules.map((item: any, index: number) => {
                    if (item.type) {
                        setTimeout(() => {
                            this.swiper[index] = new Swiper(
                                `.swiper-container${index + 1}`, {
                                    freeMode: true,
                                    freeModeMomentumRatio: 0.5,
                                    slidesPerView: 'auto',
                                    observer: false, // 修改swiper自己或子元素时，自动初始化swiper
                                    observeParents: false,// 修改swiper的父元素时，自动初始化swipe
                                    noSwiping: false,
                                    init: false
                                }
                            );
                            this.swiper[index].params.observer = true;
                            this.swiper[index].params.observeParents = true;
                            this.swiper[index].params.noSwiping = false;
                            this.swiper[index].params.noSwipingClass = '';
                            this.swiper[index].params.init = true;
                        }, 500);
                    }
                });
            });

        }
    }

    render() {
        const {goodsList, prefixCls, onAddShop, toAppDetail, onSpecialClick} = this.props;
        let len: number = goodsList ? goodsList.length : 0;
        return (
            <div style={{background: '#fff'}} key={'TimeMainGoods'}>
                {
                    goodsList && goodsList.map((item: any, index: number) => {
                        return (
                            <div key={index}>
                                {len > 1 && (
                                    <div className={`${prefixCls}-scene`}>
                                        <span/>
                                        {item.dateDeSession}
                                    </div>
                                )}
                                {
                                    item.timerShaftModules && item.timerShaftModules.map((moduleItem: any, moduleIndex: number) => {
                                        if (moduleItem.type === 0) {
                                            return moduleItem.timerShaftSkus.map((skuItem: any, skuIndex: number) => {
                                                return (
                                                    <div className={`${prefixCls}`} key={skuIndex}>
                                                        <div className={`clearfix`} style={{position: 'relative'}}
                                                             onClick={() => {
                                                                 toAppDetail && toAppDetail(skuItem.productId);
                                                             }}>
                                                            <div className={`${prefixCls}-labelBox`}>
                                                                {
                                                                    skuItem.labelImgList.map((markItem: any, markIndex: number) => {
                                                                        return (<img src={markItem} alt=""/>);
                                                                    })
                                                                }
                                                            </div>


                                                            <img src={skuItem.skuImg} className={`${prefixCls}-img`}
                                                                 alt=""/>
                                                        </div>
                                                        <div
                                                            className={`${prefixCls}-branch-name`}>{skuItem.productAd}</div>
                                                        <div
                                                            className={`${prefixCls}-words`}>{skuItem.brandsName}·{skuItem.name}</div>
                                                        <div className={`${prefixCls}-bottom-box`}>
                                                            <div className='bottom-box-left'>
                                                                <span className='bottom-box-left-icon'>¥</span>
                                                                <span
                                                                    className='bottom-box-left-num'>{skuItem.price}</span>
                                                            </div>
                                                            <div className='bottom-box-right'>
                                                                <img src={require('../../images/time-shop.png')}
                                                                     className='time-car-icon' alt=""/>
                                                                    {
                                                                        skuItem.virtual ? 
                                                                        '' 
                                                                        : 
                                                                        <div 
                                                                            className='bottom-box-right-words' 
                                                                            onClick={() => {
                                                                                onAddShop && onAddShop(skuItem);
                                                                            }}
                                                                        >
                                                                            加购物车
                                                                        </div>
                                                                    }                                                             
                                                            </div>
                                                        </div>
                                                    </div>
                                                );
                                            });
                                        } else {
                                            return (
                                                <div key={moduleIndex}>
                                                    <div className={`${prefixCls}-imgBox`} onClick={() => {
                                                        onSpecialClick && onSpecialClick(moduleItem.url);
                                                    }}>
                                                        <img src={moduleItem.img}
                                                             className={`${prefixCls}-img`}
                                                             alt=""
                                                        />
                                                    </div>
                                                    <div
                                                        className={`swiper-container ${prefixCls}-swipper swiper-container${moduleIndex + 1}`}
                                                    >
                                                        <div className={`swiper-wrapper`}>
                                                            {
                                                                moduleItem.timerShaftSkus.map((skuItem: any, skuIndex: number) => {
                                                                    return (
                                                                        <div
                                                                            key={skuIndex}
                                                                            className={`swiper-slide ${prefixCls}-times-box `}
                                                                            onClick={() => {
                                                                                toAppDetail && toAppDetail(skuItem.productId);
                                                                            }}
                                                                        >
                                                                            <img src={skuItem.img}
                                                                                 className={`${prefixCls}-theme-goods`}
                                                                                 alt=""
                                                                            />
                                                                            <div
                                                                                className={`${prefixCls}-theme-bottom`}>
                                                                                <span
                                                                                    className={`${prefixCls}-theme-bottom-icon`}>¥</span>
                                                                                <span
                                                                                    className={`${prefixCls}-theme-bottom-money`}>{skuItem.price}</span>
                                                                            </div>
                                                                        </div>
                                                                    );
                                                                })
                                                            }
                                                            <div
                                                                className={`swiper-slide ${prefixCls}-times-box ${prefixCls}-time-more`}
                                                                onClick={() => {
                                                                    onSpecialClick && onSpecialClick(moduleItem.url);
                                                                }}>
                                                                <span>查看更多</span>
                                                                <i/>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            );
                                        }
                                    })
                                }
                            </div>
                        );
                    })
                }
            </div>
        );
    }
}

export default TimeMainGoods;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/widgets/timeMainGoods/timeMainGoods.tsx